'use client'

import { useInitLivePreview } from 'utils/contentStack/hooks/useInitLivePreview/useInitLivePreview'

export function ContentStackLivePreviewInitializer() {
	useInitLivePreview()

	return null
}
